import React from "react";

/* Payment card — the card a subscription bills to. */
export const CreditCardIcon = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       aria-hidden="true" focusable="false" className={className}>
    <rect x="2.75" y="5.25" width="18.5" height="13.5" rx="2.25"
          stroke="currentColor" strokeWidth="1.7" />
    <path d="M2.75 9.75h18.5" stroke="currentColor" strokeWidth="1.7" />
    <path d="M6.5 14.5h3.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

export default CreditCardIcon;
